import { render } from "./PageForm.vue?vue&type=template&id=2df84c0a&scoped=true"
import script from "./PageForm.vue?vue&type=script&lang=js"
export * from "./PageForm.vue?vue&type=script&lang=js"

import exportComponent from "/Users/pmattern/Documents/3 - GIT/studio-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2df84c0a"]])

export default __exports__